import * as Yup from 'yup';

export const contactReferenceValidationSchema = Yup.object().shape({
  fullName: Yup.string().nullable().max(128, 'Full Name field should be max 128 symbols'),
  phoneNumber: Yup.string().phone().required('Phone Number is a required'),
  emailAddress: Yup.string().email().nullable().max(128, 'Email Address field should be max 128 symbols').email(),
  streetLine1: Yup.string().nullable().max(128, 'Address field should be max 128 symbols'),
  streetLine2: Yup.string().nullable(),
  city: Yup.string().nullable().max(128, 'City Name field should be max 128 symbols'),
  state: Yup.string(),
  zip: Yup.string().zipCode().nullable(),
  type: Yup.string().nullable(),
  county: Yup.string().nullable(),
  relationshipType: Yup.string().nullable(),
});
